<template>
    <div class="big_add_btn" @click="onClick">
        <i class="el-icon-plus avatar-uploader-icon fs12"></i>
        <span class="SysFontR fs12"><slot></slot></span>
    </div>
</template>

<script>
    /**
     * ComponentName: 添加附件按钮UI
     * Created Date:2022/4/28
     * Author: Nancy
     * 组件说明：
     * 引用组件展示附件按钮UI，点击调用
     * eg:
     *     <cl-annex></cl-annex>
     */
    export default {
        name: 'cl-annex',
        data() {
            return {

            };
        },

        methods: {
            onClick(e) {
                this.$emit('click', e)
            }
        }
    }
</script>
<style lang='scss' scoped>
    .big_add_btn {
        width: 40px;
        height: 40px;
        border: 1px dashed #C1D6EE;
        box-sizing: border-box;
        border-radius: 2px;
        text-align: center;
        cursor: pointer;
        color: $base-color-theme;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .avatar-uploader-icon{
            font-weight: 800;
        }
    }
</style>
